import React, { useContext, useState, useEffect } from "react";
import { navBarContext, authContext } from "./context/context";
import Logo from "../assets/prairiwhite.png";
import { useNavigate } from "react-router-dom";
import Settings from "./Settings";
import {
  query,
  collection,
  db,
  where,
  getDocs,
  getDoc,
  doc,
  updateDoc,
} from "../firebase/firebaseApp";
import {
  InvestorProfile,
  CompleteYourProfile,
  Loading,
  InvestorContact,
  Modal,
  BugTab,
} from "@peterfosso/prairi-components";
import Eye from "../assets/eye.png";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase/firebaseApp";
import { sendBugEmails } from "../utils";
import Rocket from "../assets/stage.gif";

const DataProfileInvestor = (props) => {
  const { navBarHeight } = useContext(navBarContext);
  const { currentUser } = useContext(authContext);
  const [docId, setDocId] = useState(null);
  const [dataFetched, setDataFetched] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [currentUserData, setCurrentUserData] = useState(null);
  const [screenshotUrl, setScreenshotUrl] = useState(""); //for bug report
  const [bugEmail, setBugEmail] = useState("");
  const [bugText, setBugText] = useState("");
  const [bugError, setBugError] = useState(null);
  const [showFirstButtons, setShowFirstButtons] = useState(true);
  const [showSecondButtons, setShowSecondButtons] = useState(true);

  let navigate = useNavigate();

  const redirectToLogin = () => {
    navigate("/login"); // Redirect to the login page
  };

  const redirectToForms = () => {
    //search for current position of the user in the forms
    navigate("/investorregistration");
  };

  useEffect(() => {
    if (dataFetched && !currentUser) {
      redirectToLogin();
    }
  }, [currentUser]);

  useEffect(() => {
    if (currentUser) {
      setDocId(currentUser.uid);
    }
  }, [currentUser]);

  const getDataFromUser = async () => {
    try {
      // Get user data from email
      const { email } = currentUser;
      const q = query(collection(db, "users"), where("email", "==", email));
      const querySnapshot = await getDocs(q);
      let userData;
      let userId;
      querySnapshot.forEach((doc) => {
        userData = doc.data();
        userId = doc.id;
      });
      setCurrentUserData(userData);
      return { userData, userId };
    } catch (error) {
      //console.log("error in getDataFromUser");
    }
  };

  const fetchData = async () => {
    try {
      if (currentUser) {
        await getDataFromUser(); // Pass the UID from currentUser
        setDataFetched(true);
      }
    } catch (error) {
      //console.log('error fetching data' + error);
    }
  };

  useEffect(() => {
    fetchData();
    //console.log("data fetched?" + JSON.stringify(dataFetched))
    //console.log(currentUserData)
  }, [currentUser]);

  const handleUpload = (e) => {
    return new Promise((resolve, reject) => {
      const selectedFile = e.target.files[0];

      const storageRef = ref(storage, `bugs/${selectedFile.name}`);
      const uploadTask = uploadBytesResumable(storageRef, selectedFile);

      uploadTask.on(
        "state_changed",
        null, // Manejador de progreso (puedes dejarlo como `null` si no necesitas reportarlo)
        (error) => {
          // Manejador de error
          console.error("Upload failed:", error);
          reject(error);
        },
        async () => {
          // Manejador de éxito
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          resolve(downloadURL);
          console.log("uploaded correctly");
          setScreenshotUrl(downloadURL);
        }
      );
    });
  };

  const handleBugText = (e) => {
    const value = e.target.value;
    setBugText(value);
    if (value !== "") {
      setBugError("");
    }
  };

  const handleBugEmail = (e) => {
    const value = e.target.value;
    setBugEmail(value);
    if (value !== "") {
      setBugError("");
    }
  };

  const validateFields = () => {
    if (!bugText || bugText.trim() === "") {
      setBugError("Please describe the bug.");
      return false;
    }
    return true;
  };

  const handleUploadAndSendEmail = async (file) => {
    try {
      if (!validateFields()) return;
  
      let uploadedUrl = screenshotUrl;
      if (file) {
        uploadedUrl = await handleUpload({ target: { files: [file] } });
      }
  
      console.log(`screenshotUrl ${uploadedUrl}`);
      sendBugEmails(
        currentUserData.email,
        currentUserData.contactName,
        bugText,
        "Investor data profile",
        uploadedUrl || ""
      );
    } catch (error) {
      console.error("Error uploading file or sending email:", error);
    }
  };
  const [showSettings, setShowSettings] = useState(false);
  const handleSettings = () => {
    setShowSettings(true);
    navigate("/settings");
  };

  if (!dataFetched) {
    return (
      <div
        id="newMatch__"
        style={{
          marginTop: navBarHeight,
          marginBottom: navBarHeight + 30,
          width: "100%",
          minWidth: "366px",
          padding: "2%",
        }}
      >
        <Loading />
      </div>
    );
  }

  return (
    <div
      id="newMatch__"
      style={{
        marginTop: navBarHeight,
        marginBottom: navBarHeight + 10,
        width: "100%",
        minWidth: "366px",
      
      }}
    >
      <section
        id="newMatch__container"
        className={`
           
      flex flex-col items-center
              m-auto  rounded-md
              py-2.5 
              min-w-[380px]
             `}
      >
        {currentUserData && (
          <BugTab
            email={currentUserData.email}
            name={currentUserData.contactName}
            setEmail={handleBugEmail}
            setText={handleBugText}
            submit={(file) => handleUploadAndSendEmail(file)}
            error={bugError}
            handleFileChange={handleUpload}
          />
        )}


        {dataFetched && currentUserData.formData && (
          <div className="w-full">
            {showFirstButtons && <div className="bg-[#f2f2f2] text-black  w-full  mb-2  flex-col flex items-center justify-center  py-2 ">
              <p className="mb-2 text-sm">Here's a summary of your preferences</p>
              <div className="flex items-center justify-center gap-4">
                <button className="border border-black text-sm rounded-full px-2 py-1" onClick={() => setShowFirstButtons(false)}> OK, looks good</button>
                <p className="underline cursor-pointer text-sm" onClick={() => navigate("/investorregistration")}>Edit Preferences</p>
              </div>
            </div>}
            {showSecondButtons && !showFirstButtons && <div className="bg-[#f2f2f2] text-black rounded-md w-full  mb-2  flex-col flex items-center justify-center  py-2 px-2">
              <p className="mb-2 text-sm">And finally, here's your profile as seen by a startup when you've matched with them and have selected 'Interested'</p>
              <div className="flex items-center justify-center gap-4">
                <button className="border border-black text-sm rounded-full px-2 py-1" onClick={() => setShowSecondButtons(false)}> OK, looks good</button>
                <p className="underline cursor-pointer text-sm" onClick={() => navigate("/investorregistration")}>Edit Data Profile</p>
              </div>
            </div>}
            
            {!showFirstButtons && !showSecondButtons && <div className="flex w-full flex-col items-center mt-24 justify-center">
              <img src={Logo} alt="Prairi" className="w-12 h-12 mb-2" />
              <div className="text-center items-center text-greenPrairi text-md my-2 w-full">
                You can now close this and go back to whatever you were doing :-)
              </div>
            </div>}
            <div
          className="flex items-center  mb-2 "
          onClick={() => setShowPreview(true)}
        >

        </div>
        {showFirstButtons && showFirstButtons && <div className="w-full flex justify-center items-center">
            <InvestorProfile
              investor={currentUserData}
              //onClose={handleSettings}
            />
            </div>}
            {!showFirstButtons && showSecondButtons && <div className="w-full flex justify-center items-center max-w-[600px] mx-auto">
            <InvestorContact
              investor={currentUserData}
              //onClose={handleSettings}
            />
            </div>}
          </div>
        )}

      </section>
      {dataFetched && (
        <CompleteYourProfile
          open={
            !currentUserData.formData ||
            !currentUserData.formData.matching.completed
          }
          click={redirectToForms}
        />
      )}
    </div>
  );
};

export default DataProfileInvestor;
